import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container menu"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = ["data-id"];
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "label-title"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import { onMounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, removeArrayItem } from "@/utils/libs";
import { InfoFilled, Plus, UploadFilled } from "@element-plus/icons-vue";
import { Sortable } from "sortablejs";
import Compressor from "compressorjs";

// 变量定义

export default {
  __name: 'Menu',
  setup(__props) {
    const items = ref([]);
    const item = ref({});
    const showDialog = ref(false);
    const title = ref("");
    const rules = reactive({
      name: [{
        required: true,
        message: "请输入菜单名称",
        trigger: "change"
      }],
      icon: [{
        required: true,
        message: "请上传菜单图标",
        trigger: "change"
      }],
      url: [{
        required: true,
        message: "请输入菜单地址",
        trigger: "change"
      }]
    });
    const loading = ref(true);
    const formRef = ref(null);
    const fetchData = () => {
      // 获取数据
      httpGet("/admin/menu/list").then(res => {
        if (res.data) {
          // 初始化数据
          const arr = res.data;
          for (let i = 0; i < arr.length; i++) {
            arr[i].last_used_at = dateFormat(arr[i].last_used_at);
          }
          items.value = arr;
        }
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取数据失败");
      });
    };
    onMounted(() => {
      const drawBodyWrapper = document.querySelector(".el-table__body tbody");
      fetchData();

      // 初始化拖动排序插件
      Sortable.create(drawBodyWrapper, {
        sort: true,
        animation: 500,
        onEnd({
          newIndex,
          oldIndex,
          from
        }) {
          if (oldIndex === newIndex) {
            return;
          }
          const sortedData = Array.from(from.children).map(row => row.querySelector(".sort").getAttribute("data-id"));
          const ids = [];
          const sorts = [];
          sortedData.forEach((id, index) => {
            ids.push(parseInt(id));
            sorts.push(index + 1);
            items.value[index].sort_num = index + 1;
          });
          httpPost("/admin/menu/sort", {
            ids: ids,
            sorts: sorts
          }).catch(e => {
            ElMessage.error("排序失败：" + e.message);
          });
        }
      });
    });
    const add = function () {
      title.value = "新增菜单";
      showDialog.value = true;
      item.value = {};
    };
    const edit = function (row) {
      title.value = "修改菜单";
      showDialog.value = true;
      item.value = row;
    };
    const save = function () {
      formRef.value.validate(valid => {
        if (valid) {
          showDialog.value = false;
          if (!item.value.id) {
            item.value.sort_num = items.value.length + 1;
          }
          httpPost("/admin/menu/save", item.value).then(() => {
            ElMessage.success("操作成功！");
            fetchData();
          }).catch(e => {
            ElMessage.error("操作失败，" + e.message);
          });
        } else {
          return false;
        }
      });
    };
    const enable = row => {
      httpPost("/admin/menu/enable", {
        id: row.id,
        enabled: row.enabled
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const remove = function (row) {
      httpGet("/admin/menu/remove?id=" + row.id).then(() => {
        ElMessage.success("删除成功！");
        items.value = removeArrayItem(items.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };

    // 图片上传
    const uploadImg = file => {
      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append("file", result, result.name);
          // 执行上传操作
          httpPost("/admin/upload", formData).then(res => {
            item.value.icon = res.data.url;
            ElMessage.success("上传成功");
          }).catch(e => {
            ElMessage.error("上传失败:" + e.message);
          });
        },
        error(e) {
          ElMessage.error("上传失败:" + e.message);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: add
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto",
          border: "",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "菜单名称"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              class: "sort",
              "data-id": scope.row.id
            }, [_cache[7] || (_cache[7] = _createElementVNode("i", {
              class: "iconfont icon-drag"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(scope.row.name), 1)], 8, _hoisted_3)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "icon",
            label: "菜单图标"
          }, {
            default: _withCtx(scope => [scope.row.icon.startsWith('icon') ? (_openBlock(), _createElementBlock("span", _hoisted_4, [_createElementVNode("i", {
              class: _normalizeClass(["iconfont", scope.row.icon]),
              style: {
                "font-size": "30px"
              }
            }, null, 2)])) : (_openBlock(), _createBlock(_component_el_image, {
              key: 1,
              class: "menu-icon",
              src: scope.row.icon
            }, null, 8, ["src"]))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "url",
            label: "菜单URL"
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['enabled'],
              "onUpdate:modelValue": $event => scope.row['enabled'] = $event,
              onChange: $event => enable(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => edit(scope.row)
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showDialog.value = $event),
        title: title.value,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: item.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "菜单名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => item.value.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[10] || (_cache[10] = _createTextVNode(" 开放注册 ")), _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "可以填写 iconfont 图标名称也可以自己上传图片",
              "raw-content": "",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.icon,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => item.value.icon = $event),
              placeholder: "菜单图标地址"
            }, {
              append: _withCtx(() => [_createVNode(_component_el_upload, {
                "auto-upload": true,
                "show-file-list": false,
                "http-request": uploadImg
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  class: "uploader-icon"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "菜单URL：",
            prop: "url"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.url,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => item.value.url = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态：",
            prop: "enable"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: item.value.enabled,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => item.value.enabled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])])), [[_directive_loading, loading.value]]);
    };
  }
};